'use client'
import React from 'react';
import styled from 'styled-components';
import {hover, text} from "@/styles/globalStyleVars";
import parser from "html-react-parser";

const Title = ({
                   text,
                   fontSize,
                   fontWeight,
                   color,
                   letterSpacing,
                   lineHeight,
                   textTransform,
                   margin,
                   marginMobile,
                   padding,
                   borderColor,
                   center,
                   classname,
                   fontFamily,subtitle, noanim
               }) => {


    return (

        <StyledTitle className={`title ${classname}`}
                     fontSize={fontSize}
                     fontWeight={fontWeight}
                     color={color}
                     lineHeight={lineHeight}
                     LetterSpacing={letterSpacing}
                     textTransform={textTransform}
                     margin={margin}
                     marginMobile={marginMobile}
                     padding={padding}
                     center={center}
                     borderColor={borderColor}
                     fontFamily={fontFamily}
        >
            {
                subtitle?
                    text &&  <h3 className={noanim ? '' :'split-up'}>{parser(text)} </h3> :
                    text &&  <h2 className={noanim ? '' :'split-up'}>{parser(text)} </h2>
            }

        </StyledTitle>

    )
};


const StyledTitle = styled.div`
  margin: ${props => props.margin || '0px 0px 40px 0px'};
  position: relative;
  width: 100%;
  text-align: ${props => props?.center ? 'center' : ''};
  padding: ${p => p.padding};

  h2 {
    font-size: ${props => props.fontSize || 40}px;
    line-height: ${props => props.lineHeight || 50}px;
    // font-weight: ${props => props.fontWeight || 900};
    color: ${props => props.color || text};
    //text-transform: uppercase;
    

    span {
      color: ${hover};
    }
  }
  
  h3 {
    font-size: ${props => props.fontSize || 28}px;
    line-height: ${props => props.lineHeight || 36}px;
    color: ${props => props.color || text};
    //text-transform: uppercase;   

    span {
      color: ${hover};
    }
  }


  @media (max-width: 767px) {
    margin: ${props => props.marginMobile || '0px'};
    text-align: start !important;

    h2 {
      font-size: 28px !important;
      line-height: 36px !important;
      margin-bottom: 30px;
    }
  }
`;

export default React.memo(Title);














